import { render, staticRenderFns } from "./PurchaseSum.vue?vue&type=template&id=42f27d16&scoped=true"
import script from "./PurchaseSum.vue?vue&type=script&lang=js"
export * from "./PurchaseSum.vue?vue&type=script&lang=js"
import style0 from "./PurchaseSum.vue?vue&type=style&index=0&id=42f27d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f27d16",
  null
  
)

export default component.exports